import { Pipe, PipeTransform } from '@angular/core';

import { WW_ICONS } from '../constants';
import moment from 'moment';

@Pipe({ name: 'weatherCondition' })
export class WeatherConditionPipe implements PipeTransform {
  transform(value: any, args: any[] = null): any {
    const today = moment();
    const beginningTime = today?.clone().set({ h: 6, m: 0, s: 0 });
    const endTime = today?.clone().set({ h: 18, m: 0, s: 0 });
    if (today.isBetween(beginningTime, endTime, 'milliseconds', '[]')) {
      return WW_ICONS[value].day;
    } else {
      return WW_ICONS[value].night;
    }
  }
}
